export default "__VITE_ASSET__r_0ObmSd__"